import { SidebarProvider, SidebarTrigger } from "@always_faithful/shadcn/components/ui/sidebar";
import AppSidebar from "./AppSidebar";
import { Outlet, useMatchRoute, useNavigate } from "@tanstack/react-router";
import Footer from "../layout/Footer"
import {useEffect, useState} from "react";
import LogoutButtonMobile from "../components/account-page/LogOutTelephone.js";
import { useSidebar } from "@always_faithful/shadcn/components/ui/sidebar"

function CustomTrigger() {
    const { toggleSidebar } = useSidebar()
    const matchRoute = useMatchRoute();
    const [currentPath, setCurrentPath] = useState(location.pathname);

    useEffect(() => {
        setCurrentPath(location.pathname);
    }, [location.pathname]);

    const isAccountPage = matchRoute({ to: "/user" });
    const isVacanciesPage = matchRoute({ to: "/vacancies"})
    const isBlogPostPage = matchRoute({ to: "/post/$id"})
    const isBlogEditForm = matchRoute({ to: "/admin/blog/edit"})
    const isReportModal = matchRoute({to: "/report/$id"})
    const isReportEditForm = matchRoute({ to: "/admin/report/edit"})
    const isAdminLogin = matchRoute({ to: "/admin/global-login"})
    const isCurrAdminLogin = matchRoute({ to: "/admin/current-admin-login"})
    const isAdminPanel = matchRoute({ to: "/admin/home-page"})
    const isPolicyPage = matchRoute({to: "/policy-page"})

    const vacancyRoutes = new Set([
        "/vacancy/edit",
        "/vacancy/view",
        "/vacancy/apply"
    ]);
    const isVacancyRoute = [...vacancyRoutes].some(route => currentPath.startsWith(route));

    return(
        <svg
            onClick={toggleSidebar}
            className={`m-4 pt-0.5 bg-transparent absolute top-0 z-10
                ${isVacanciesPage || isBlogPostPage || isVacancyRoute || isAdminLogin || isCurrAdminLogin || isAdminPanel || isBlogEditForm || isReportEditForm || isReportModal || isPolicyPage ? "stroke-gray-900" :
                ( isAccountPage ? "stroke-gray-700" : "stroke-white")}
            `}
            width="34" height="34" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
            <path d='M4.5 6.5h15M4.5 12h15m-15 5.5h15'/>
        </svg>
    )
}

function SideNavbar() {
    const navigate = useNavigate();
    const matchRoute = useMatchRoute();
    const [currentPath, setCurrentPath] = useState(location.pathname);

    useEffect(() => {
        setCurrentPath(location.pathname);
    }, [location.pathname]);

    const isAccountPage = matchRoute({ to: "/user" });
    const isVacanciesPage = matchRoute({ to: "/vacancies"})
    const isBlogPostPage = matchRoute({ to: "/post/$id"})
    const isBlogEditForm = matchRoute({ to: "/admin/blog/edit"})
    const isReportModal = matchRoute({to: "/report/$id"})
    const isReportEditForm = matchRoute({ to: "/admin/report/edit"})
    const isAdminLogin = matchRoute({ to: "/admin/global-login"})
    const isCurrAdminLogin = matchRoute({ to: "/admin/current-admin-login"})
    const isAdminPanel = matchRoute({ to: "/admin/home-page"})
    const isPolicyPage = matchRoute({to: "/policy-page"})

    const vacancyRoutes = new Set([
        "/vacancy/edit",
        "/vacancy/view",
        "/vacancy/apply"
    ]);
    const isVacancyRoute = [...vacancyRoutes].some(route => currentPath.startsWith(route));

    return (
        <SidebarProvider>
            <AppSidebar />
            <main>
                <CustomTrigger />
                <div className="m-4 bg-transparent absolute right-0 z-10">
                    {isAccountPage || isAdminPanel ?
                        <LogoutButtonMobile /> :
                        <div className={`${isVacanciesPage || isBlogPostPage || isVacancyRoute || isAdminLogin || isCurrAdminLogin || isAdminPanel || isBlogEditForm || isReportEditForm || isReportModal || isPolicyPage ? "stroke-gray-900" : "stroke-white"}`} onClick={() => navigate({ to: "/user"})}>
                            <svg width="34" height="34" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                                <path d='M3 9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 3 7.16 3 9.4 3h5.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.04 21 7.16 21 9.4v5.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C17.96 21 16.84 21 14.6 21H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 17.96 3 16.84 3 14.6z'/><path d='M14.5 9.25a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M7 20.5v-1.3c.317-6.187 9.683-6.187 10 0v1.3'/>
                            </svg>
                        </div>
                    }
                </div>

                <div>
                    <Outlet/>
                </div>
                <Footer />
            </main>
        </SidebarProvider>
    );
}

export default SideNavbar;